import React from "react";
import { NavLink } from "react-router-dom";
import "./css/logo.scss";

function Logo() {
  return (
    <div className="logo">
      <NavLink className="logo__container container" to="/">
        {" "}
        <img src="/img/svg/logo.svg" alt="" />
      </NavLink>
    </div>
  );
}

export default Logo;
